import { useRequest } from 'ahooks'
import { useEffect } from 'react'

import { certificateFromData } from '@/components/NewEditForm/UILibrary/HYBElement/BlockLevel/BlockLevelForm/utils'
import { http } from '@/utils'

import getQuery from '@/utils/getQuery'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'

// 人员信息详情
const personnelDetails = (id?: any): any => http.get(`/hrm/employee/${id}`, { params: { id } })
// 奖惩记录 添加/编辑
const saveRewardPunishment = (data: any): any => http.post('/hrm/reward_punishment', data)
// 奖惩记录 批量删除
const deletesHrmRewardPunishment = (data: any): any =>
  http.delete('/hrm/reward_punishments', { data })

export default ({ value, onConfirm }: any) => {
  const { open, modalData, onCancel, onOpen } = usePopup({})
  // 奖惩记录 添加/编辑
  const { run: runSaveRewardPunishment, loading: saveRewardPunishmentLoading } = useRequest(
    saveRewardPunishment,
    {
      manual: true,
      onSuccess: (result: any) => {
        const { code } = result
        if (code === 2000) {
          onCancel()
          onConfirm()
        }
      },
      onError: ({ message }) => {
        console.log('error', message)
      }
    }
  )

  // 奖惩记录 批量删除
  const { run: runDeleteHrmRewardPunishment, loading: deleteHrmRewardPunishmentLoading } =
    useRequest(deletesHrmRewardPunishment, {
      manual: true,
      onSuccess: (result: any) => {
        const { code } = result
        if (code === 2000) {
          onCancel()
          onConfirm()
        }
      },
      onError: ({ message }) => {
        console.log('error', message)
      }
    })
  const add = () => {
    onOpen({ status: 'Add', editItem: {} })
  }

  const edit = (index: number) => {
    const fieldValues = value?.[index] || {}
    const attachments = certificateFromData(fieldValues?.attachment_files || [])
    onOpen({ status: 'Edit', editItem: { ...fieldValues, attachments } })
  }
  return {
    add,
    edit,
    open,
    modalData,
    onCancel,
    onOpen,
    runDeleteHrmRewardPunishment,
    runSaveRewardPunishment,
    deleteHrmRewardPunishmentLoading,
    saveRewardPunishmentLoading
  }
}
